var formExists = setInterval(function() {
	if ($('.nf-form-content').length) {
		
		// service cancellation option to redirect to the form page
		$('.service-cancellation-option input:radio').on('click', function() {
			if( $(this).val() == 'Cancellation') {
				let serviceCancellationPageUrl = $('.ninja-forms-section').attr('data-serviceCancellationPage');
				if(serviceCancellationPageUrl != '') {
					window.location.href = serviceCancellationPageUrl;
				}
			} 
		});

		$(".organization-search").each(function() {
			// Set your event listeners here, example:
			var orgSearchWrapper = $(this);
			
			const companyField = orgSearchWrapper.find(
				'input.ninja-forms-field'
			)

			let d365maCompanies = []
			function onCompanyOptionMouseDown(e) {
				let index = parseInt(e.delegateTarget.id.replace('option-', ''))
				let companyInfo = d365maCompanies[index]

				companyField.val(
					`${companyInfo.businessName} (${companyInfo.orgNr})`
				).trigger("change")
				
				let companyDetails = `${companyInfo.businessName}~${companyInfo.orgNr}~${companyInfo.companyId}~${companyInfo.addressId}`
				let cookieKey = "company-info-"+companyField.attr('id');
				window.Cookies.set(cookieKey, companyDetails);

			}

			function onCompanyOptionHover(e) {
				orgSearchWrapper.find('ul#companies-suggestions')
					.children('.dropdown-option--highlight')
					.first()
					.removeClass('dropdown-option--highlight')
				$(e.delegateTarget).addClass('dropdown-option--highlight')
			}

			function onCompanyFieldBlur() {
				orgSearchWrapper.find('ul#companies-suggestions').css('display', 'none')
				orgSearchWrapper.find('ul#companies-suggestions').css('visibility', 'hidden')
			}

			function onCompanyFieldFocus() {
				orgSearchWrapper.find('ul#companies-suggestions').removeAttr('style')
			}

			function onCompanyFieldKeyDown() {
				switch (event.which || event.keyCode) {
					case 40: // Down
						if (
							orgSearchWrapper.find('ul#companies-suggestions').children(
								'.dropdown-option--highlight'
							)[0] !==
							orgSearchWrapper.find('ul#companies-suggestions')
								.children('li')
								.last()[0]
						) {
							orgSearchWrapper.find('ul#companies-suggestions')
								.children('.dropdown-option--highlight')
								.first()
								.removeClass('dropdown-option--highlight')
								.next()
								.addClass('dropdown-option--highlight')
							orgSearchWrapper.find('ul#companies-suggestions').scrollTop(
								document.getElementById(
									document.querySelector(
										'.dropdown-option--highlight'
									).id
								).offsetTop - 10
							)
						}
						break

					case 38: // Up
						if (
							orgSearchWrapper.find('ul#companies-suggestions').children(
								'.dropdown-option--highlight'
							)[0] !==
							orgSearchWrapper.find('ul#companies-suggestions')
								.children('li')
								.first()[0]
						) {
							orgSearchWrapper.find('ul#companies-suggestions')
								.children('.dropdown-option--highlight')
								.first()
								.removeClass('dropdown-option--highlight')
								.prev()
								.addClass('dropdown-option--highlight')

							orgSearchWrapper.find('ul#companies-suggestions').scrollTop(
								document.getElementById(
									document.querySelector(
										'.dropdown-option--highlight'
									).id
								).offsetTop - 10
							)
						}
						break

					case 13: // Enter
						var selected = orgSearchWrapper.find('ul#companies-suggestions')
							.children('.dropdown-option--highlight')
							.first()
						if (selected.length > 0) {
							onCompanyOptionMouseDown({
								delegateTarget: selected[0]
							})
							companyField
						}
						break

					case 27: // Esc
						companyField.blur()
						break

					default:
						return
				}

				event.preventDefault()
			}

			function onCompanyFieldInput() {
				orgSearchWrapper.find('ul#companies-suggestions')
					.children()
					.remove()
				var company = companyField.val()
				if (company === '') return

				let url = '/wp-json/api/v1/business_search?query='+company
			
				$.ajax({
					type: 'post',
					url: '/wp-json/api/v1/business_search?query='+company,
					success: function (data) {
						orgSearchWrapper.find('ul#companies-suggestions').empty()
						let i = 0
						let elements = []
						d365maCompanies = data
						data.forEach(o => {
							let orgNo = $('<span>').text(`(${o.orgNr})`)
							let divElement = $('<div>')
								.addClass(`option flag-${o.countryCode}`)
								.append(`${o.businessName} `, orgNo)
							let liElement = $('<li>')
								.attr('id', `option-${i}`)
								.addClass('dropdown-option')
								.mousedown(onCompanyOptionMouseDown)
								.hover(onCompanyOptionHover)
								.append(divElement)
							orgSearchWrapper.find('ul#companies-suggestions').append(liElement)
							i++
						})

						orgSearchWrapper.find('ul#companies-suggestions')
							.children('.dropdown-option')
							.first()
							.addClass('dropdown-option--highlight')
					}
				})


			}

			companyField.attr('autocomplete', 'off')
			companyField.attr('type', 'search')
			companyField.blur(onCompanyFieldBlur)
			companyField.focus(onCompanyFieldFocus)
			companyField.keydown(onCompanyFieldKeyDown)
			companyField.on('input', onCompanyFieldInput)
			companyField.after(
				`<ul id="companies-suggestions" class="companies-suggestions" style="display: none; visibility: hidden;" tabindex="-1">
				<li id="no-option-found" class="no-options">
					<p>Vennligst skriv inn firmanavnet eller org.nr ditt</p>
				</li>
			</ul>`
			)
			clearInterval(formExists)
		});
	}
}, 100) // check every 100ms